import Link from "next/link";

import { Card } from "@/components/ui/card";
import { contactLinks } from "@/util";

export const Contact = () => (
  <Card
    id="contact"
    className="py-14 px-4 md:py-16 2xl:p-20 scroll-mt-40 !mb-20 md:!mb-40"
    stars
  >
    <h4 className="leading-snug lg:leading-normal tracking-tight text-2xl md:text-3xl lg:text-6xl relative text-center first-letter:capitalize">
      Let&apos;s Connect
    </h4>
    <p className="text-xs md:text-sm lg:text-base text-center mt-2">
      Contact Me for Collaborations or Projects
    </p>
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 mt-8">
      {contactLinks.map(({ icon, id, title, url, username }) => (
        <Link key={id} href={url}>
          <div className="border rounded-2xl group p-2 xl:p-4 hover:bg-themeWhite/5 transition-all duration-300">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="border overflow-hidden p-3 relative rounded-xl bg-[linear-gradient(to_right,#2128293a_1px,transparent_1px),linear-gradient(to_bottom,#2128293a_1px,transparent_1px)] bg-[size:10px_10px]">
                  <div className="fill-grain">{icon()}</div>
                  <div className="blur-sm w-6 h-6 bg-themeBlue/50 rounded-full absolute lxy-center -z-10" />
                </div>
                <div>
                  <div className="text-lg select-none capitalize">{title}</div>
                  <div className="text-xs italic">{username}</div>
                </div>
              </div>
              <div className="p-2 rounded-full shrink-0 border relative overflow-hidden fill-grain">
                <svg
                  className="will-change-transform w-5 h-5 stroke-themeWhite group-hover:translate-x-6 group-hover:-translate-y-6 group-hover:opacity-0 opacity-100 transition-all duration-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="0.7"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
                  />
                </svg>
                <svg
                  className="will-change-transform w-5 h-5 -left-4 -bottom-4 opacity-0 stroke-themeWhite absolute group-hover:translate-x-6 group-hover:opacity-100 group-hover:-translate-y-6 transition-all duration-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="0.7"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
                  />
                </svg>
              </div>
            </div>
          </div>
        </Link>
      ))}
    </div>
  </Card>
);
